import type { DocumentTypes, UploadedDocument } from '@urbanx/agx-ui-components';

export const haveAllGeneratedDocumentsReady = (
  expectedDocumentTypes: DocumentTypes[],
  generatedDocuments: UploadedDocument[]
) =>
  expectedDocumentTypes.length > 0 &&
  expectedDocumentTypes.every((documentType) =>
    generatedDocuments.some((document) => document.documentType === documentType)
  );
